import { useOutlet } from "react-router-dom";
import { AuthProvider } from "../hooks/useAuth";
import { AppDataProvider } from "@/providers/app-data-provider";

export const AuthLayout = () => {
    const outlet = useOutlet();

    return (
        <AuthProvider>
            <AppDataProvider>{outlet}</AppDataProvider>
        </AuthProvider>
    );
};
